import { render, staticRenderFns } from "./el_aside.vue?vue&type=template&id=37c17a02&scoped=true&"
import script from "./el_aside.vue?vue&type=script&lang=js&"
export * from "./el_aside.vue?vue&type=script&lang=js&"
import style0 from "./el_aside.vue?vue&type=style&index=0&id=37c17a02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c17a02",
  null
  
)

export default component.exports